// src/hooks/useLearners.js
import { message } from "antd";
import newEmployeesService from "PlatForms/OrgLMS/Services/ManagerService/newEmployeesService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useNewEmployees = (token) => {
  const [learners, setLearners] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [loadingRowId, setLoadingRowId] = useState(null);

  const fetchLearners = async () => {
    try {
      setLoading(true);
      const data = await newEmployeesService.getUnassignedLearners(token);
      setLearners(data);
    } catch (error) {
      console.error("Error fetching learners:", error);
    } finally {
      setLoading(false);
    }
  };

  const pickLearner = async (learnerId) => {
    try {
      setLoadingRowId(learnerId);
      await newEmployeesService.pickLearnerByManager(learnerId, token);
      message.success("Assign as Employee Successfully");
      navigate("/employees");
      fetchLearners();
    } catch (error) {
      console.error("Error picking learner:", error);
    } finally {
      setLoadingRowId(null);
    }
  };

  useEffect(() => {
    fetchLearners();
  }, []);

  return {
    learners,
    loading,
    loadingRowId,
    pickLearner,
  };
};

export default useNewEmployees;
